export enum TaskType {
    TT_TASK = 'TT_Task',
    TT_MILE = 'TT_Mile',
    TT_FIN_MILE = 'TT_FinMile',
    TT_RSRC = 'TT_Rsrc',
    TT_WBS = 'TT_WBS',
    TT_LOE = 'TT_LOE',
}